import React from 'react'
import './boton.css'
import { motion } from 'framer-motion'

const Button = ({link, text, build, addClass, handleActivePopUp, popData}) => {

  const variants = {
    initial: { opacity: 0, y: -40, skewX: -10 },
    inView: { opacity: 1, y: 0, skewX: 0 },
  }

  return (
    <motion.a
    variants={variants}
    initial={'initial'}
    whileInView={'inView'}
    viewport={{ once: true }}
    transition={{ duration: 0.7 }}
    className={build ? 'boton build' : 'boton' }
    href={link}
    onClick={() => handleActivePopUp(popData)}
    >
        {text}
        {
            build && <svg viewBox="0 0 29 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M12.4103 12.7382L17.8273 0.55001L16.5897 0L11.1728 12.1882L12.4103 12.7382ZM6.85336 2.10804L1.91519 7.04622L6.85336 11.9844L5.89577 12.942L0.478797 7.52502L0 7.04622L0.478797 6.56742L5.89577 1.15045L6.85336 2.10804ZM22.1458 11.9844L27.084 7.04627L22.1458 2.10809L23.1034 1.1505L28.5204 6.56747L28.9992 7.04627L28.5204 7.52506L23.1034 12.942L22.1458 11.9844Z" fill="#D9D9D9"/>
                    </svg>
            
        }
    </motion.a>
  )
}

export default Button